<template>
  <div>
    <b-card no-body class="mb-0">
      <b-form @submit="Update()">
        <validation-observer ref="simpleRules">
          <div class="m-2">
            <b-row class="d-flex justify-content-between w-100">
              <b-col md="12">
                <h2
                  class="font-weight-bolder"
                  style="font-weight: 400; color: black"
                >
                  Audio
                </h2>
              </b-col>
              <b-col md="12">
                <b-media>
                  <template #aside> </template>

                  <p class="media-heading d-flex justify-content-between">
                    <!-- <b-avatar size="32" :src="notification.avatar" :text="notification.avatar" :variant="notification.type" /> -->
                    <!-- <span class="font-weight-bolder">
                                {{ notification.title }}
                            </span> -->
                    <!-- <span class="dot" :class="{ 'dot-read': notification.read, 'dot-unread': !notification.read }"></span> -->
                  </p>
                  <!-- <small class="notification-text">{{ notification.subtitle }}</small><br> -->
                  <!-- <small class="notification-time">{{NotificationUpdate}}</small> -->
                </b-media>
              </b-col>
            </b-row>
            <!-- <b-row>
              <new-audio />
            </b-row> -->

            <b-card no-body class="shadow">
              <b-row class="w-100 p-5">
                <b-col md="1" class="d-flex">
                  <div class="mt-2">
                    <b-img
                      class="logo-image"
                      src="/logo.png"
                    >
                      <!-- src="../../../../../public/rspt1.png" -->
                    </b-img>
                  </div>
                </b-col>
                <b-col md="6" class="cursor-pointer">
                  <!-- <audio class="audio" controls>
                                        <source src='../../../../assets/audio/in-the-forest-2-21402.mp3' type="audio/mp3">
                                            Your browser does not support the audio element.
                                      </audio> -->
                  <div class="mt-2">
                    <h5>BEEP Test <small>(By My PODA Admin)</small></h5>
                  </div>
                  <div class="d-flex justify-content-between w-100">
                    <span>{{ formatTime(currentTime) }}</span>
                    <span>{{ formatTime(totalTime) }}</span>
                  </div>
                  <div>
                    <b-progress
                      v-model="progress"
                      @click="handleChange($event)"
                      variant="dark"
                      :max="10000"
                      :style="{
                        'border-radius': '5px',
                      }"
                    >
                    </b-progress>
                    <!-- :value="caculateProgressPercentage" -->
                  </div>
                  <div
                    @click="toggleMute()"
                    class="d-flex justify-content-end mt-1"
                  >
                    <svg
                      width="23"
                      height="18"
                      viewBox="0 0 23 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        :d="
                          isMuted
                            ? 'M7.09204 5.53888H2.05892C1.85586 5.53937 1.66124 5.61972 1.51748 5.76241C1.37372 5.9051 1.29249 6.09856 1.2915 6.3006V12.3869C1.29249 12.5889 1.37372 12.7824 1.51748 12.9251C1.66124 13.0678 1.85586 13.1481 2.05892 13.1486H7.09391C7.09391 13.1486 7.46826 13.2771 7.50757 13.3032L10.6989 15.9794V2.19775L7.58431 5.31353C7.52348 5.38424 7.44798 5.441 7.363 5.4799C7.27802 5.5188 7.18558 5.53892 7.09204 5.53888Z'
                            : 'M2.05892 4.25383H6.82625L10.8879 0.186372C11.0084 0.0682004 11.1708 0.00195313 11.34 0.00195312C11.5091 0.00195312 11.6715 0.0682004 11.792 0.186372C11.8521 0.245836 11.8997 0.316684 11.9318 0.394733C11.964 0.472783 11.9801 0.55645 11.9792 0.640796V17.3576C11.9787 17.4854 11.94 17.6101 11.8681 17.716C11.7962 17.8219 11.6943 17.9041 11.5754 17.9522C11.4564 18.0003 11.3258 18.0121 11.2 17.9862C11.0743 17.9602 10.9591 17.8977 10.8692 17.8064L6.85995 14.4318H2.05892C1.51286 14.4318 0.989166 14.216 0.603043 13.8318C0.216921 13.4476 0 12.9265 0 12.3832L0 6.3006C0 5.75727 0.216921 5.23619 0.603043 4.852C0.989166 4.46781 1.51286 4.25197 2.05892 4.25197V4.25383ZM14.2477 7.04742C14.2156 6.97106 14.1997 6.88891 14.201 6.80614C14.2023 6.72337 14.2209 6.64177 14.2555 6.56648C14.29 6.49119 14.3399 6.42384 14.4019 6.36867C14.464 6.31349 14.5368 6.2717 14.6159 6.24591C14.6949 6.22011 14.7785 6.21089 14.8613 6.21881C14.9441 6.22673 15.0244 6.25163 15.0971 6.29193C15.1697 6.33223 15.2332 6.38707 15.2836 6.45298C15.3339 6.5189 15.37 6.59447 15.3895 6.67494C15.6147 7.47874 15.7132 8.31246 15.6815 9.14633C15.6646 10.0328 15.5355 10.9044 15.2828 11.4203C15.2503 11.4948 15.2029 11.5621 15.1436 11.6179C15.0843 11.6737 15.0142 11.717 14.9376 11.7452C14.861 11.7733 14.7795 11.7857 14.6979 11.7816C14.6163 11.7776 14.5365 11.7571 14.4631 11.7215C14.3897 11.6858 14.3243 11.6358 14.2709 11.5743C14.2175 11.5129 14.1771 11.4413 14.1523 11.3639C14.1274 11.2865 14.1186 11.2049 14.1263 11.124C14.134 11.0431 14.1581 10.9646 14.1972 10.8933C14.3713 10.5357 14.4648 9.85218 14.4779 9.12771C14.5068 8.42977 14.4291 7.73152 14.2477 7.05673V7.04742ZM17.3623 4.81255C17.3007 4.66437 17.3009 4.49793 17.3627 4.34984C17.4244 4.20175 17.5428 4.08414 17.6917 4.0229C17.8407 3.96165 18.0079 3.96177 18.1568 4.02324C18.3056 4.08471 18.4238 4.2025 18.4854 4.35068C19.0469 5.68787 19.3482 7.37334 19.3744 9.04762C19.4006 10.7219 19.1554 12.3478 18.6257 13.6608C18.5962 13.7341 18.5525 13.801 18.497 13.8576C18.4416 13.9141 18.3754 13.9592 18.3024 13.9904C18.2294 14.0215 18.151 14.038 18.0716 14.039C17.9922 14.04 17.9133 14.0253 17.8396 13.996C17.7659 13.9666 17.6987 13.9231 17.6418 13.8679C17.585 13.8127 17.5396 13.747 17.5083 13.6743C17.477 13.6017 17.4604 13.5236 17.4595 13.4446C17.4585 13.3656 17.4732 13.2872 17.5027 13.2138C17.9688 12.0386 18.184 10.5524 18.1559 9.05135C18.1278 7.55026 17.8602 6.00448 17.3548 4.80324L17.3623 4.81255ZM20.3739 2.90732C20.3395 2.8364 20.3195 2.75942 20.315 2.68079C20.3105 2.60216 20.3216 2.52342 20.3476 2.44905C20.3737 2.37469 20.4142 2.30616 20.4669 2.24739C20.5196 2.18861 20.5834 2.14074 20.6547 2.1065C20.726 2.07226 20.8033 2.05232 20.8824 2.04783C20.9614 2.04334 21.0405 2.05438 21.1153 2.08032C21.2662 2.13271 21.3901 2.24261 21.4596 2.38585C22.4635 4.50954 22.9898 6.82554 23.0019 9.1724C23.0187 11.4482 22.5583 13.7148 21.555 15.6479C21.4806 15.7894 21.3526 15.8957 21.1994 15.9434C21.0462 15.9911 20.8802 15.9762 20.738 15.9021C20.5958 15.8281 20.489 15.7008 20.441 15.5483C20.3931 15.3959 20.408 15.2307 20.4825 15.0892C21.3959 13.333 21.8133 11.2601 21.7927 9.1724C21.7833 7.00283 21.2978 4.86147 20.3702 2.89801L20.3739 2.90732Z'
                        "
                        fill="black"
                      />
                    </svg>
                  </div>
                </b-col>
                <b-col
                  md="1"
                  class="bg-light-primary d-flex"
                  style="width: 100px"
                >
                  <div class="mt-1">
                    <span>
                      <svg
                        width="50"
                        id="masterPlay"
                        v-if="!isPlaying"
                        @click="togglePlayPause"
                        height="50"
                        class="mt-2 cursor-pointer"
                        style="margin: 0 10px 0 10px"
                        viewBox="0 0 64 64"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g filter="url(#filter0_d_229_11662)">
                          <circle cx="32" cy="32" r="29" fill="white" />
                        </g>
                        <path
                          d="M26.1568 22.0576C26.1126 22.0894 26.0611 22.1648 26.0353 22.2243C26.0059 22.3077 25.9948 24.9239 26.0022 32.5661L26.0133 42.8006L26.1053 42.8999C26.3151 43.1261 25.7593 43.4477 34.6483 37.9215C39.1499 35.1227 42.8712 32.7844 42.919 32.7328C42.9706 32.6693 43 32.582 43 32.4946C43 32.4033 42.9706 32.3239 42.919 32.2683C42.8712 32.2207 42.0577 31.6967 41.1044 31.1051C40.1548 30.5136 36.5182 28.2507 33.0251 26.0792C29.5321 23.9076 26.6243 22.1013 26.558 22.0616C26.4108 21.9822 26.2562 21.9782 26.1568 22.0576Z"
                          fill="black"
                        />
                        <defs>
                          <filter
                            id="filter0_d_229_11662"
                            x="0"
                            y="0"
                            width="64"
                            height="64"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feMorphology
                              radius="1"
                              operator="dilate"
                              in="SourceAlpha"
                              result="effect1_dropShadow_229_11662"
                            />
                            <feOffset />
                            <feGaussianBlur stdDeviation="1" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_229_11662"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect1_dropShadow_229_11662"
                              result="shape"
                            />
                          </filter>
                        </defs>
                      </svg>

                      <svg
                        width="50"
                        v-else
                        @click="togglePlayPause"
                        height="50"
                        class="mt-2 cursor-pointer"
                        style="margin: 0 10px 0 10px"
                        viewBox="0 0 64 64"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g filter="url(#filter0_d_43_12590)">
                          <circle cx="32" cy="32" r="29" fill="white" />
                        </g>
                        <path
                          d="M24.1533 24.0543C24.1179 24.0819 24.0707 24.1409 24.0472 24.1881C24.0118 24.2511 24 26.203 24 32.0115V39.7523L24.114 39.8664L24.228 39.9806H27.2228C30.5754 39.9806 30.4064 39.9963 30.485 39.7051C30.5085 39.6185 30.5243 36.8048 30.5243 31.9604C30.5243 23.7946 30.5321 24.1527 30.3356 24.0465C30.2138 23.9796 24.2397 23.9874 24.1533 24.0543Z"
                          fill="black"
                        />
                        <path
                          d="M33.4918 24.1015L33.3936 24.1959V31.9878V39.7758L33.5154 39.8782L33.6372 39.9805H36.6439H39.6506L39.7645 39.8663L39.8785 39.7522V31.98V24.2117L39.7803 24.1054L39.6859 24.0031H36.636H33.5861L33.4918 24.1015Z"
                          fill="black"
                        />
                        <defs>
                          <filter
                            id="filter0_d_43_12590"
                            x="0"
                            y="0"
                            width="64"
                            height="64"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feMorphology
                              radius="1"
                              operator="dilate"
                              in="SourceAlpha"
                              result="effect1_dropShadow_43_12590"
                            />
                            <feOffset />
                            <feGaussianBlur stdDeviation="1" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_43_12590"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect1_dropShadow_43_12590"
                              result="shape"
                            />
                          </filter>
                        </defs>
                      </svg>
                    </span>
                    <div class="mt-1" style="margin-bottom: 5px">
                      <span>
                        <svg
                          class="cursor-pointer"
                          width="14"
                          height="21"
                          @click="nextSong()"
                          viewBox="0 0 14 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.279305 10.8317C0.335007 10.9112 12.3704 20.2304 12.5264 20.314C12.6786 20.4015 12.7677 20.3895 12.9014 20.2583L13.024 20.1429L13.0351 10.78C13.0425 5.63312 13.0351 1.34938 13.024 1.2579C12.9868 0.983452 12.7752 0.824354 12.5635 0.911858C12.4447 0.959587 0.386996 10.2828 0.294158 10.3981C0.219889 10.4896 0.212462 10.7362 0.279305 10.8317Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                      <span>
                        <svg
                          width="15"
                          height="16"
                          class="mx-1 cursor-pointer"
                          @click="stopSong()"
                          viewBox="0 0 15 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.112694 0.114285L0 0.228571V8V15.7714L0.112694 15.8857L0.225389 16H7.5H14.7746L14.8873 15.8857L15 15.7714V8V0.228571L14.8873 0.114285L14.7746 0H7.5H0.225389L0.112694 0.114285Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                      <svg
                        class="cursor-pointer"
                        width="13"
                        @click="nextSong()"
                        id="nextButton"
                        height="20"
                        viewBox="0 0 13 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.917 9.62488C12.8613 9.54533 0.825905 0.226114 0.669939 0.142587C0.517686 0.0550831 0.428563 0.0670155 0.294878 0.198272L0.172333 0.313619L0.161192 9.67658C0.153765 14.8234 0.161192 19.1072 0.172332 19.1986C0.209467 19.4731 0.421135 19.6322 0.632803 19.5447C0.751635 19.497 12.8093 10.1738 12.9021 10.0584C12.9764 9.96694 12.9838 9.72033 12.917 9.62488Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card>
          </div>
        </validation-observer>
      </b-form>
    </b-card>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BFormFile,
  BButton,
  BForm,
  BSpinner,
  BMedia,
  BImg,
  BProgressBar,
  BProgress,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import axios from "axios";
import { quillEditor } from "vue-quill-editor";
import { required } from "@validations";
export default {
  components: {
    BCard,
    BImg,
    BProgress,
    BProgressBar,
    BMedia,
    required,
    BSpinner,
    BFormFile,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BForm,
    quillEditor,
  },
  data() {
    return {
      snowOption: {
        theme: "snow",
      },
      accessToken: localStorage.getItem("accessToken"),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      data: [],
      isSideDataLoading: false,
      currentTrackIndex: 0,
      progress: 0,
      tracks: [
        // { name: 'Track 1', url: '../../../../../public/WhatsApp Audio 2024-01-04 at 2.40.18 PM (1).mpeg' },
      ],
      isPlaying: false,
      audioElement: new Audio(
        "https://rsptfitness.s3.eu-north-1.amazonaws.com/video/FWpVVZJUZq1uy0CEp1ZrLkwmGFlLZawcIp7Q54ue.mp3"
      ),
      // @/assets/audio/RSPT-MUSIC.mpeg.wav
      songStatus: "stopped", // 'playing', 'paused', 'stopped'
      currentTime: 0,
      totalTime: 22, 
      intervalId: null,
      isMuted: false,
      // masterPlay:'',
      // previous:'',
      // next:'',
      image: "",
    };
  },
  computed: {
    // calculateProgressPercentage() {
    //   this.progress = parseInt(
    //     (this.audioElement.currentTime / this.audioElement.duration) * 10000
    //   );
    // },
    progressColor() {
      const thresholdTime = 0;
      return this.currentTime < thresholdTime ? "white" : "black";
    },
  },
  mounted() {
    // this.getNotification();
    this.audioElement.addEventListener('loadedmetadata', this.updateProgress);
  },
  beforeDestroy() {
    if (this.audioElement) {
      this.audioElement.removeEventListener('loadedmetadata', this.updateProgress);
    }
  },
  methods: {
    handleChange(event) {
      // If event is provided (indicating a click event on the progress bar)
      if (event) {
        const progressBar = event.target;
        const clickedPositionX =
          event.clientX - progressBar.getBoundingClientRect().left;
        const progressBarWidth = progressBar.clientWidth;
        const percentageClicked = clickedPositionX / progressBarWidth;
        const seekTime = percentageClicked * this.audioElement.duration;

        // Set the audio's current time to the calculated seek time
        this.audioElement.currentTime = seekTime;

        // Update the progress bar value to reflect the seeked position
        this.progress = (seekTime / this.audioElement.duration) * 10000;
      }
      //  else {
      //   // If no event is provided, calculate progress normally
      //   this.progress =
      //     (this.audioElement.currentTime / this.audioElement.duration) * 10000;
      // }
    },
    // handleChange() {
    //   this.audioElement.currentTime =
    //     (this.progress * this.audioElement.duration) / 10000;
    // },
    toggleMute() {
      this.isMuted = !this.isMuted;
      this.audioElement.muted = this.isMuted;
    },
    updateTime() {
      this.currentTime = this.convertSecondsToTime(this.audio.currentTime);
    },
    togglePlayPause() {
      // console.log("here is osnafa")
      // this.audioElement.src = process.env.VUE_APP_AUDIO;
      if (this.isPlaying) {
        this.audioElement.pause();
      } else {
        this.audioElement.play();
        this.audioElement.addEventListener("timeupdate", this.updateProgress);
      }
      this.isPlaying = !this.isPlaying;
    },
    stopSong() {
      this.audioElement.pause();
      // this.audioElement.currentTime = 0;
      this.isPlaying = false;
    },
    nextSong() {
      this.audioElement.pause();
      this.audioElement.currentTime = 0;
      this.isPlaying = false;
    },
    updateProgress() {
      this.progress = parseInt(
        (this.audioElement.currentTime / this.audioElement.duration) * 10000
      );
      this.currentTime = this.audioElement.currentTime;
      this.totalTime = this.audioElement.duration;
    },
    formatTime(time) {
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60);
      return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    },
    convertSecondsToTime(seconds) {
      // Convert seconds to time format (mm:ss)
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = Math.floor(seconds % 60);
      const formattedMinutes = String(minutes).padStart(2, "0");
      const formattedSeconds = String(remainingSeconds).padStart(2, "0");
      return `${formattedMinutes}:${formattedSeconds}`;
    },
    async getNotification() {
      this.isSideDataLoading = false;
      await axios({
        method: "GET",
        url: `${this.baseApi}nutrition/get`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
        .then((json) => {
          this.data = json?.data;
        })
        .catch((error) => console.log(error, "error"))
        .finally(() => {
          this.isSideDataLoading = false;
        });
    },
  },
};
</script>
<style>
.logo-image {
  height: 70px;
  width: 70px;
}

button {
  margin: 0 10px;
  padding: 5px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 20px;
  color: #333;
  /* Change as needed */
}

button:hover {
  color: #555;
  /* Change as needed */
}
.shadow {
  box-shadow: 20px 11px 94px 0px rgba(0, 0, 0, 0.8);
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/quill.scss";
</style>
  
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
  
  